export default {
  type: "Feature",
  properties: {
    name: "Сүхбаатар",
    location: [49.68054, 106.45556],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [104.51911926269531, 49.106017014812096],
        [104.53628540039062, 49.15296965617039],
        [104.54864501953125, 49.22836014090129],
        [104.5953369140625, 49.3653834114396],
        [104.61181640625, 49.3993562906839],
        [104.64065551757812, 49.435984899682005],
        [104.66537475585938, 49.48775429690567],
        [104.67086791992188, 49.54481568504451],
        [104.67361450195312, 49.64451295574021],
        [104.732666015625, 49.686289508355735],
        [104.688720703125, 49.73779410787209],
        [104.58297729492188, 49.81229016526221],
        [104.53216552734375, 49.85303710579436],
        [104.51568603515625, 49.90082667133223],
        [104.51156616210938, 49.983020075472226],
        [104.58023071289062, 49.98743510374161],
        [104.60220336914062, 49.993615462541136],
        [104.61456298828124, 50.0086215988794],
        [104.55551147460938, 50.05008477838258],
        [104.54864501953125, 50.10032188683107],
        [104.52117919921874, 50.14962639292665],
        [104.45114135742186, 50.21557967003726],
        [104.36067581176758, 50.26454594544213],
        [104.359130859375, 50.2612538275847],
        [104.3865966796875, 50.31390041107301],
        [104.51293945312499, 50.32091555536218],
        [104.556884765625, 50.31039245071915],
        [104.6502685546875, 50.33494273843299],
        [104.67773437499999, 50.366488762738264],
        [104.77111816406249, 50.3454604086048],
        [104.8590087890625, 50.3734961443035],
        [104.8974609375, 50.40851753069729],
        [105.018310546875, 50.39451208023374],
        [105.150146484375, 50.401515322782366],
        [105.27099609375, 50.440014664018136],
        [105.2764892578125, 50.47498691278631],
        [105.3314208984375, 50.48197825997291],
        [105.413818359375, 50.450509053586615],
        [105.523681640625, 50.46100111599232],
        [105.6170654296875, 50.440014664018136],
        [105.72143554687499, 50.433017111356605],
        [105.7928466796875, 50.447011182312195],
        [105.919189453125, 50.42251884281916],
        [106.0675048828125, 50.40501655606602],
        [106.094970703125, 50.34896578114507],
        [106.171875, 50.341954777309994],
        [106.2872314453125, 50.31039245071915],
        [106.4300537109375, 50.327929664466296],
        [106.4794921875, 50.317408112618686],
        [106.4959716796875, 50.3454604086048],
        [106.80908203125, 50.306884231551166],
        [107.017822265625, 50.20503326494332],
        [107.083740234375, 50.064191736659104],
        [107.28149414062499, 49.990083926193954],
        [107.3309326171875, 50.004208515595614],
        [107.46826171874999, 49.983020075472226],
        [107.7264404296875, 49.9759551873433],
        [107.80334472656249, 49.94061518401988],
        [107.9681396484375, 49.94061518401988],
        [107.9351806640625, 49.86277585341321],
        [107.9791259765625, 49.809631563563094],
        [107.9461669921875, 49.72092792670335],
        [108.017578125, 49.66762782262192],
        [108.292236328125, 49.53946900793534],
        [108.3636474609375, 49.42169406084924],
        [108.52844238281249, 49.32512199104001],
        [108.57118606567381, 49.33116330436252],
        [108.57152938842772, 49.33116330436252],
        [108.533935546875, 49.224772722794825],
        [108.52140426635742, 49.12410690961098],
        [108.52226257324219, 49.124668601968175],
        [108.44467163085938, 49.12511795127304],
        [108.3306884765625, 49.1170290407793],
        [108.23867797851562, 49.08915713896701],
        [108.16314697265625, 49.059469847170526],
        [108.08761596679688, 49.00995159747052],
        [107.99011230468749, 49.0549702248979],
        [107.91046142578125, 49.074765516185],
        [107.85552978515625, 49.0765646971094],
        [107.7923583984375, 49.0765646971094],
        [107.67288208007812, 49.05677012268616],
        [107.59185791015625, 49.017157315497165],
        [107.53143310546875, 48.97751295870069],
        [107.59597778320312, 48.89812957181126],
        [107.63168334960936, 48.879167148960214],
        [107.70584106445312, 48.857487002645485],
        [107.73056030273438, 48.83579746243093],
        [107.73468017578125, 48.81048112472012],
        [107.71270751953125, 48.75890477584505],
        [107.67013549804688, 48.68552087440201],
        [107.65090942382812, 48.64561313162894],
        [107.62619018554688, 48.63018576693964],
        [107.5836181640625, 48.62564740882851],
        [107.52319335937499, 48.63109338958398],
        [107.46826171874999, 48.60748989475176],
        [107.25128173828125, 48.558431982894355],
        [107.20184326171875, 48.59931688270807],
        [107.14279174804688, 48.615661584266824],
        [107.09335327148438, 48.61747733567233],
        [106.98348999023438, 48.60204136700653],
        [106.8695068359375, 48.60204136700653],
        [106.82418823242188, 48.57933284084407],
        [106.7596435546875, 48.532975799741635],
        [106.68823242187499, 48.516604348867475],
        [106.578369140625, 48.52933815687993],
        [106.47674560546875, 48.56024979174331],
        [106.46301269531249, 48.58296689084418],
        [106.44653320312499, 48.592050872804194],
        [106.171875, 48.68733411186308],
        [106.11145019531249, 48.66012869453836],
        [106.0675048828125, 48.64833511799889],
        [106.01394653320312, 48.669198799260045],
        [105.98785400390625, 48.68824070611104],
        [106.00982666015624, 48.731738037020946],
        [106.02630615234374, 48.76886223397753],
        [106.01943969726562, 48.80957673328024],
        [105.9686279296875, 48.84393214092012],
        [105.82992553710938, 48.865618158309374],
        [105.65139770507811, 48.83579746243093],
        [105.57037353515625, 48.816811408054306],
        [105.44540405273438, 48.75799945448167],
        [105.49346923828125, 48.64561313162894],
        [105.31768798828125, 48.59114254808809],
        [105.2490234375, 48.56024979174331],
        [105.15838623046875, 48.545705491847464],
        [105.06500244140625, 48.511146022547344],
        [104.99359130859375, 48.507506811647325],
        [104.8809814453125, 48.53843177405044],
        [104.52804565429688, 48.62564740882851],
        [104.52821731567383, 48.625760872755635],
        [104.51980590820312, 48.66103577846602],
        [104.51568603515625, 48.73264383158835],
        [104.54452514648436, 48.786961645533275],
        [104.47723388671875, 48.83941303819501],
        [104.37801361083984, 48.89948375541988],
        [104.37698364257812, 48.89993514180326],
        [104.47723388671875, 48.942347261978476],
        [104.56100463867188, 48.99463598353408],
        [104.57061767578125, 49.026162996368946],
        [104.53765869140625, 49.06936758241039],
        [104.5184326171875, 49.105342729732754],
        [104.51911926269531, 49.106017014812096],
      ],
    ],
  },
};
